import IconButton from '@mui/material/IconButton'
import LightModeIcon from '@mui/icons-material/LightModeOutlined'
import DarkModeIcon from '@mui/icons-material/DarkModeOutlined'
import { useTranslation } from 'react-i18next'
import { useThemeMode, toggleThemeMode } from '../themeMode'

/**
 * Sunny Chick ⇄ Midnight Rooster toggle (light/dark). Shared by the storefront header and the
 * owner console; the mode is global (see themeMode.ts). Shows the mode you'd switch TO.
 */
export default function ModeToggle({ color = 'inherit' }: { color?: string }) {
  const { t } = useTranslation()
  const mode = useThemeMode()
  return (
    <IconButton aria-label={t('common.toggleTheme')} onClick={toggleThemeMode} sx={{ color }}>
      {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
    </IconButton>
  )
}
